export { SSOImg } from '@monorepo/shared-lib';
